/* eslint-disable prettier/prettier */
import { ENV } from '@environment';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { RootState } from 'store';

import { getVersion } from 'utils/version';

const version = getVersion();

const SENTRY_DSN = ENV.SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  normalizeDepth: 10,
  tracesSampleRate: 1.0,
  enabled: false, //125721 al revés de quitar toda la logica
  environment: version.environment,
  release: version.sha,
  beforeSend: (event) => {
    if (event.contexts && 'redux.state' in event.contexts) {
      const store = event.contexts['redux.state'] as unknown as RootState;
      const { accountResult } = store.user;

      if (accountResult && accountResult.id) {
        event.user = {
          id: accountResult.id,
          username: `${accountResult.name} ${accountResult.lastName}`,
          email: accountResult.email,
        };
      }
    }

    return event;
  },
});

Sentry.setTag('build.tag', version.tag || 'none');
Sentry.setTag('build.branch', version.branch);
Sentry.setTag('build.sha', version.sha);
Sentry.setTag('build.timestamp', version.date.toISOString());
